import { apiFetch } from "./api";
import type { NotificationSeverity } from "./notifications-api";

export type AnnouncementAudienceType =
  | "ALL_EMPLOYEES"
  | "ALL_ADMINS"
  | "DEPARTMENT"
  | "SITE"
  | "SPECIFIC_EMPLOYEES";

export interface AnnouncementAudience {
  type: AnnouncementAudienceType;
  /** Managed department IDs (ADR-0008). */
  departments?: string[];
  siteIds?: string[];
  employeeIds?: string[];
}

export interface CreateAnnouncementBody {
  title: string;
  body: string;
  severity?: NotificationSeverity;
  audience: AnnouncementAudience;
}

export interface AnnouncementResult {
  id: string;
  recipients: number;
}

export const announcementsApi = {
  send: (body: CreateAnnouncementBody) =>
    apiFetch<AnnouncementResult>(`/announcements`, { method: "POST", body }),
};
